import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
export function convertArrayToMap(array, key) {
  return array.reduce(function (acc, item) {
    acc[item[key]] = item;
    return acc;
  }, {});
}